import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getMonthWiseHolidays = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/monthly-holidays${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getYearWiseHolidays = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/holidays${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createHoliday = (data, token) =>
  axios.post(`${baseUrl}/add-holiday`, data, {
    headers: {
      authorization: token,
    },
  });

export const updateHoliday = (id, data, token) =>
  axios.patch(`${baseUrl}/holiday/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getHolidayById = (id, token) =>
  axios.get(`${baseUrl}/holiday/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const deleteHoliday = (id, token) =>
  axios.delete(`${baseUrl}/holiday/${id}`, {
    headers: {
      authorization: token,
    },
  });
